<app-modal [title]="(weekExists() ? 'Edit' : 'Add') + ' Banking Collection'" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">

    <app-checkbox-group
            [options]="daysOptions"
            [selectedValues]="selectedDays()"
            [hasSeveralColumns]="true"
            (checkboxToggled)="onDaysChange($event)">
    </app-checkbox-group>

    <app-input-date
            [isDisabled]="weekExists()"
            [placeholder]="'Start date'"
            [name]="'startDate'"
            [inputDate]="selectedStartDate()"
            (inputDateChange)="selectedStartDate.set($event)"
            [editDate]="editDate"
            [onlyMondays]="true">
    </app-input-date>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !selectedStartDate() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>